import { AccountCategory, type HolisticSummaryCategory } from '@fruitful/types';
import { capitalize } from 'lodash';
import * as React from 'react';
import { BodyMediumRegular, SelectSingle, Sheet, YStack } from 'smoothie';

interface EditCategorySheetProps {
    isOpen: boolean;
    onClose: () => void;
    onSelectCategory: (category: HolisticSummaryCategory) => void;
    selectedCategory: HolisticSummaryCategory;
}

const EditCategorySheet = ({
    isOpen,
    onClose,
    onSelectCategory,
    selectedCategory,
}: EditCategorySheetProps) => {
    const categories = [
        AccountCategory.SPEND,
        AccountCategory.SAVE,
        AccountCategory.INVEST,
        AccountCategory.BORROW,
    ];

    const options = categories.map((category) => ({
        title: capitalize(category),
    }));

    const selectedIndex = categories.findIndex(
        (category) => category === selectedCategory,
    );

    const handleSelect = (index: number) => {
        const category = categories[index];
        if (category != null) {
            onSelectCategory(category as HolisticSummaryCategory);
        }
    };

    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            title="Category"
            showCloseButton
        >
            <YStack alignItems="center">
                <BodyMediumRegular marginVertical={12}>
                    This is the category where your account will show up on the
                    home tab of the app.
                </BodyMediumRegular>
                <YStack width="100%" maxWidth={480} alignSelf="center">
                    <SelectSingle
                        options={options}
                        selectedIndex={selectedIndex}
                        onSelect={handleSelect}
                    />
                </YStack>
            </YStack>
        </Sheet>
    );
};

export default EditCategorySheet;
